import React from 'react'
import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import packageJson from '../../../package.json'

export function loader() {
	return json({ version: packageJson.version })
}

const Index = () => {
	const { version } = useLoaderData<typeof loader>()

	return <div className="flex justify-center p-5 align-middle">{version}</div>
}

export default Index
